import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApiPartnerService } from '@app/api/api-partner.service';
import swal from "sweetalert/dist/sweetalert.min.js";

@Component({
  selector: 'app-launcher-version',
  templateUrl: './launcher-version.component.html',
  styleUrls: ['./launcher-version.component.css']
})
export class LauncherVersionComponent implements OnInit {

  listLauncherVersions: any[] = [];
  tableLoad = true;
  paging: any = {};
  meta: any = {};
  lastIndex = 0;
  firstIndex = 0;
  totalCount = 0;
  limit = 10;
  currentParams: any = {};
  queryParams = '';
  mSearch = '';
  querySearch = false;
  pageSelf: any = {};
  pageNext: any = {};
  pagePrev: any = {};
  searchQueryParams = '';
  itemSet: any = {};

  formSet: FormGroup;
  showModal = false;

  selectedApk: string | ArrayBuffer | null = null;
  selectedApkFile: File = null;

  constructor(
    private partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.formSet = this.fb.group({
      id: [''],
      partnerId: [''],
      partnerName: [''],
      currentVersion: [''],
      newVersion: [''],
      forceUpdate: [''],
      apkFile: [null]
    });
  }

  alertsx(message: any) {
    swal({
      title: "Sukses!",
      text: message,
      icon: "success",
    });
    setTimeout(() => {
      this.closeModal();
      this.ngOnInit();
    }, 1000);
  }

  alertfx(message: any) {
    swal({
      title: "Gagal!",
      text: message,
      icon: "error",
    });
  }

  ngOnInit(): void {
    this.loadLauncherVersion();
  }

  loadLauncherVersion(params: string = ''): void {
    this.tableLoad = true;
    this.partnerService.GetLauncherVersions(params).subscribe({
      next: (output: any) => {
        this.listLauncherVersions = output.data;
        this.tableLoad = false;

        this.paging = output.pagex;
        this.pageSelf = output.pagex.self;
        this.pageNext = output.pagex.next;
        this.pagePrev = output.pagex.prev;
        this.meta = output.meta;
        this.totalCount = this.meta['totalCount'];

        const selfPage = this.pageSelf['page'];
        if (selfPage * this.meta['perPage'] < this.meta['totalCount']) {
          this.lastIndex = selfPage * this.meta['perPage'];
        } else {
          this.lastIndex = this.meta['totalCount'];
        }
        this.firstIndex = (selfPage - 1) * this.meta['perPage'] + 1;
      },
      error: () => {
        this.tableLoad = false;
      }
    });
  }

  queryStr(options: any): string {
    const params = new URLSearchParams();
    for (const key in options) {
      params.set(key, options[key]);
    }
    return params.toString();
  }

  loadStart(): void {
    this.route.queryParams.subscribe((params) => {
      if (params.search) {
        this.mSearch = params.search;
        this.querySearch = true;
      } else {
        this.querySearch = false;
      }

      this.currentParams = params;
      this.queryParams = '?' + this.queryStr(params);
      this.loadLauncherVersion(this.queryParams);
    });

    this.mSearch = '';
  }

  refreshPage(): void {
    this.ngOnInit();
  }

  search(): void {
    this.querySearch = true;
    const search = this.mSearch;
    const limit = this.limit;
    const page = this.pageSelf.page

    this.searchQueryParams = `?page=${page}&search=${search}&limit=${limit}`;
    this.loadLauncherVersion(this.searchQueryParams);
  }

  onActionClick(item: any): void {
    if (!item) return;

    this.itemSet = item;

    console.log('Item dipilih:', item);

    this.formSet.patchValue({
      id: item.id != null ? item.id : null,
      partnerId: item.id_partner != null ? item.id_partner : null,
      partnerName: item.partner_name != null ? item.partner_name : '',
      currentVersion: item.current_version != null ? item.current_version : '',
      newVersion: item.new_version != null ? item.new_version : '',
      forceUpdate: item.force_update != null ? item.force_update.toString() : '0'
    });

    this.showModal = true; // tampilkan modal Angular
  }

  closeModal(): void {
    this.showModal = false;
  }

  onFileSelected(event: Event, fileType: string): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files[0]) {
      const file = input.files[0]; // Ambil file yang dipilih
      const reader = new FileReader();

      reader.onload = (e: ProgressEvent) => {
        const fileReader = e.target as FileReader;

        if (fileReader) {
          this.selectedApk = fileReader.result;
          this.selectedApkFile = file; // Simpan hasil sebagai data URL untuk preview

          console.log('File APK dipilih:', this.selectedApkFile);
        }
      }

      reader.readAsDataURL(file);
    }
  }

  submitAdd(): void {
    if (this.formSet.invalid) return;

    // Buat payload postData dari form
    const postData = {
      id_partner: this.formSet.value.partnerId,
      current_version: this.formSet.value.currentVersion,
      new_version: this.formSet.value.newVersion,
      force_update: this.formSet.value.forceUpdate,
    };

    // Siapkan FormData untuk multipart/form-data
    const formData = new FormData();
    formData.append('id_partner', postData.id_partner);
    formData.append('current_version', postData.current_version);
    formData.append('new_version', postData.new_version);
    formData.append('force_update', postData.force_update);

    // Tambahkan file APK jika ada
    if (this.selectedApkFile) {
      formData.append('apk_file', this.selectedApkFile, this.selectedApkFile.name);
    }

    console.log('FormData entries:');
    for (const [key, value] of (formData as any).entries()) {
      console.log(key, value);
    }

    this.partnerService.UpdateLauncherVersions(formData).subscribe({
      next: (output: any) => {
        console.log('Response dari server:', output);
        this.loadLauncherVersion(this.queryParams); // refresh tabel
        this.closeModal();
        this.alertsx(output.message);
      },
      error: (err) => {
        this.alertfx(err.message || 'Terjadi kesalahan saat mengupdate data.');
        console.error('Gagal update launcher version:', err);
      }
    });
  }

  trackByFn(index: number): number {
    return index;
  }
}